
import { ADD_TO_CART, REMOVE_ITEM, SUB_QUANTITY, ADD_QUANTITY, FETCH_ITEMS, FETCH_REQUEST, ADD_TO_ORDERS, SELECT_MAIN_CATEGORY } from '../actions/action-types/cart-actions'
import redux from 'redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import axios from 'axios'

const initState = {

    loading: true,
    items: [],
    addedItems: [], topping: "",
    total: 0,
    mainCategory: "",
    orders: [],


}

export const fetchItems = items => {
    return {
        type: FETCH_ITEMS,
        payload: items
    }
}

export const fetchRequest = () => {
    return {
        type: FETCH_REQUEST

    }
}

export const addToCart = (id) => {

    return {
        type: ADD_TO_CART,
        id
    }
}
//remove item action
export const removeItem = (id) => {
    return {
        type: REMOVE_ITEM,
        id
    }
}
//subtract qt action
export const subtractQuantity = (id) => {
    return {
        type: SUB_QUANTITY,
        id
    }
}
//add qt action
export const addQuantity = (id) => {
    return {
        type: ADD_QUANTITY,
        id
    }
}
// fetch items

export const addToOrders = (orderData) => {
    return {
        type: ADD_TO_ORDERS,
        orderData
    }
}
// select main category

export const selectMainCategory = (id) => {
    return {
        type: SELECT_MAIN_CATEGORY,
        id
    }
}

const cartReducer = (state = initState, action) => {

    if (action.type === SELECT_MAIN_CATEGORY) {
        let mainCategory = action.id

        return {
            ...state,
            mainCategory: mainCategory,

        }
    }


    if (action.type === FETCH_ITEMS) {
        return {
            ...state,
            loading: false,
            items: action.payload
        }
    }

    if (action.type === FETCH_REQUEST) {
        return {
            ...state,
            loading: true
        }
    }
    //INSIDE HOME COMPONENT
    if (action.type === ADD_TO_CART) {
        var actionid = parseInt(action.id.substring(0, action.id.indexOf("_")))
        var actionbaseid = parseInt(action.id.substring(action.id.indexOf("_") + 1));

        var category = action.id.substring(action.id.indexOf(":") + 1)
        var category = category.substring(0, category.indexOf("*"))
        var subCategory = action.id.substring(action.id.indexOf("*") + 1)
        if (actionid == 0 && subCategory == "addComment") {
            let added_Item = state.items.find(item => item.id == actionbaseid)
            added_Item.comments = category;
            console.log(added_Item)
        } else {
            let added_Item = state.items.find(item => item.id == actionid)

            //check if the action id exists in the addedItems
            let existed_baseitem = null;
            let addedItem = null;
            if (added_Item.category === "Base")// added item is a base
            {
                existed_baseitem = state.addedItems.find(item => item.id == actionid)
                if (existed_baseitem === undefined) //base item new
                {
                    addedItem = added_Item;
                    addedItem.quantity = 1;
                    let newTotal = state.total + parseFloat(addedItem.price)

                    return {
                        ...state,
                        addedItems: [...state.addedItems, addedItem],
                        topping: state.topping + "~" + addedItem.title
                    }


                }
                else // base item exist
                {
                    if (category == "remove") {
                        state.items.find(item => item.id == actionid).quantity -= 1
                    } else {
                        state.items.find(item => item.id == actionid).quantity += 1
                        newTotal = state.total + parseFloat(added_Item.price)
                    }
                    return {
                        ...state,

                        topping: state.topping

                    }

                }

            }
            else // added item is a topping
            {
                existed_baseitem = state.addedItems.find(item => item.id == actionbaseid)

                let dArray = null;
                let nArray = null;
                let dressingArray = null;
                let toppings_string = existed_baseitem.topping;

                if (toppings_string.length >= 0 || added_Item.category === "Beverage") {
                    state.topping = state.topping + "~" + added_Item.title;
                    if (category == "Choice") {

                        dArray = state.addedItems.find(item => item.id == actionbaseid);

                        if (dArray['topping'].length >= 1) {
                            nArray = dArray['topping'].find(i => i.subCategory == subCategory)
                            if (nArray != null) {
                                dArray['topping'] = dArray['topping'].filter(item => item.id != nArray.id)

                                state.topping = state.topping.replace("~" + nArray.title, "")
                            }
                        }

                    }

                    state.addedItems.find(item => item.id == actionbaseid).topping.push({ "id": added_Item.id, "category": added_Item.category, "subCategory": added_Item.subCategory, "title": added_Item.title, "price": added_Item.price });
                }


                newTotal = parseFloat(state.total)
                return {
                    ...state,
                    topping: state.topping
                }

            }
        }
    }
    if (action.type === REMOVE_ITEM) {
        var actionid = parseInt(action.id.substring(0, action.id.indexOf("_")))
        var actionbaseid = action.id.substring(action.id.indexOf("_") + 1);
        if (actionbaseid.startsWith("index")) {
            actionbaseid = parseInt(actionbaseid.substring(actionbaseid.indexOf("-") + 1))
            var orderDetail = state.orders[actionbaseid];
            var new_Items = state.orders
            var removed_item = [];
            amount = 0
            orderDetail.topping.forEach(element => {
                if (element.category == "ExtraItem") {
                    amount = amount + parseFloat(element.price) * parseInt(orderDetail.quantity)
                }
            });

            let newTotal = state.total - parseFloat(orderDetail.price) * parseInt(orderDetail.quantity) - parseFloat(amount)

            removed_item.push(state.orders.splice(actionbaseid, 1));

            return {
                ...state,
                orders: new_Items,
                total: newTotal
            }
        } else {
            var actionbaseid = parseInt(actionbaseid);
            let itemToRemove = state.addedItems.find(x => x.id == actionbaseid)
            let new_items = state.addedItems.filter(y => y.id != actionbaseid)

            var newTotal = 0;
            if (state.total > 0) {
                if (actionid == actionbaseid || actionid == 0) {
                    newTotal = parseFloat(state.total)
                } else {
                    newTotal = parseFloat(state.total) - (parseFloat(itemToRemove.price) * parseFloat(itemToRemove.quantity))
                }

            }
            return {
                ...state,
                addedItems: new_items,
                total: newTotal,
                topping: state.topping
            }
        }



        //}
    }
    //INSIDE CART COMPONENT
    if (action.type === ADD_QUANTITY) {
        var actionid = parseInt(action.id.substring(0, action.id.indexOf("_")))
        var index = parseInt(action.id.substring(action.id.indexOf("_") + 1));
        var orderDetail = state.orders[index];
        orderDetail.quantity = parseInt(orderDetail.quantity) + 1;

        amount = 0
        orderDetail.topping.forEach(element => {
            if (element.category == "ExtraItem") {
                amount = amount + parseFloat(element.price)
            }
        });

        let newTotal = state.total + parseFloat(orderDetail.price) + parseFloat(amount);

        return {
            ...state,
            total: newTotal,
            topping: state.topping
        }
    }
    if (action.type === SUB_QUANTITY) {
        var actionid = parseInt(action.id.substring(0, action.id.indexOf("_")))
        var ind = parseInt(action.id.substring(action.id.indexOf("_") + 1));

        var orderDetail = state.orders[ind];
        orderDetail.quantity = parseInt(orderDetail.quantity) - 1
        var new_Items = state.orders
        var removed_item = [];

        amount = 0
        orderDetail.topping.forEach(element => {
            if (element.category == "ExtraItem") {
                amount = amount + parseFloat(element.price)
            }
        });

        if (orderDetail.quantity == 0) {  //if the quantity == 0 then it should be removed
            removed_item.push(state.orders.splice(ind, 1));
        }

        let newTotal = state.total - (parseFloat(orderDetail.price)) - parseFloat(amount)


        return {
            ...state,
            orders: new_Items,
            total: newTotal,
        }
    }

    if (action.type === ADD_TO_ORDERS) {
        var orderData = action.orderData;
        var orderArray = null;
        orderArray = { "id": orderData.id, "title": orderData.title, "quantity": orderData.quantity, "topping": orderData.topping, "price": orderData.price, "mainCategory": orderData.mainCategory, "comments": orderData.comments,image:orderData.img }
        var orderItem = state.orders
        var amount = 0

        orderData.topping.forEach(element => {
            if (element.category == "ExtraItem") {
                amount = amount + parseFloat(element.price) * parseInt(orderData.quantity)
            }
        });

        amount = parseFloat(state.total) + parseFloat(orderData.quantity) * parseFloat(orderData.price) + parseFloat(amount)

        orderItem.push(orderArray);


        return {
            ...state,
            orders: orderItem,
            total: amount.toFixed(2)
        }

    }
    else {
        return {
            ...state,

        }
    }

}
export default cartReducer




export const fetchData = () => {
    return (dispatch) => {
        dispatch(fetchRequest)
        axios.get('https://apps2.housing.k-state.edu/code/bakery/getInventory.php?revenue=Bakery')
            .then(response => {
                const items = response.data

                dispatch(fetchItems(items))
            })

    }
}
